import ReactMarkdown from 'react-markdown';
import { OneColumnExpanded } from '@/pages/Home';
import Footer from '@/components/Footer';
import {
  HeaderContainer,
  MainContainer,
  NavContainer,
} from '@/components/OurPlans/styled';
import { Row } from '@simplywallst/ui-core';
import { OneColumn } from '@/components/Layout';
import DocumentHeader from '@/components/DocumentHeader';
import { Navigation } from '@/components/Navigation';
import { Header, InnerContainer } from './styled';
import { useQuery } from '@tanstack/react-query';
import { queryKey, getTermsAndConditions } from './query';
import loadable from '@loadable/component';

const LoadingOverlay = loadable(() => import('@/components/LoadingOverlay'));

const TermsAndConditions = () => {
  const { data: queriedData, status } = useQuery({
    queryKey,
    queryFn: getTermsAndConditions,
    staleTime: Infinity,
  });

  if (status === 'pending') return <LoadingOverlay />;
  if (typeof queriedData === 'undefined') return <LoadingOverlay />;
  const data = queriedData['terms-and-conditions'];

  return (
    <>
      <MainContainer>
        <HeaderContainer justifyContent="center">
          <OneColumn>
            <DocumentHeader allowCrawlers title="Terms And Conditions" />
            <NavContainer>
              <Navigation />
            </NavContainer>
            <Header>
              <h1>{data?.title ?? ''}</h1>
              {data?.subtitle && <p>{data.subtitle}</p>}
            </Header>
          </OneColumn>
        </HeaderContainer>
        <Row justifyContent="center">
          <InnerContainer>
            <ReactMarkdown
              data-cy-id="hero1"
              source={data?.longContentOne ?? ''}
            />
          </InnerContainer>
        </Row>
      </MainContainer>
      <OneColumnExpanded>
        <Footer />
      </OneColumnExpanded>
    </>
  );
};

export default TermsAndConditions;
